import React from "react";
import GoogleReviews from "./reviewCarousell";
import { ElfsightWidget } from "react-elfsight-widget";
import { WhatsAppWidget } from "react-whatsapp-widget";
import "react-whatsapp-widget/dist/index.css";
import "./socials.css";

function Socials() {
  return (
    <div className="flex-container">
      <div className="review-widget widgetControl">
        <GoogleReviews />
        <div className="elfsight">
          <ElfsightWidget widgetId="20e00fc1-2e4f-4a84-8bf2-83d05934c7c8" />
        </div>
      </div>
      <div
        className="whatsapp-widget widgetControl"
        style={{
          position: "fixed",
          right: "1px", // Keep it on the right side
          bottom: "15%", // Position it halfway up the page
          transform: "translateY(50%)", // Center it vertically
          zIndex: 1, // Use a very high z-index
        }}
      >
        <WhatsAppWidget
          phoneNumber="91839577"
          companyName="2J True Beauty"
          message="Ready to experience our lastest bioelectric TCM therapy? Contact us now!"
        />
      </div>

        <iframe
        className="medium"
          src="https://widgets.sociablekit.com/medium-publication-feed/iframe/25483245"
          title="Medium Blog"
          style={{
            border: "0",
            frameborder: "0 !important",
            width: "100%",
            height: "150vh",
          }}
        ></iframe>{" "}
    </div>
  );
}

export default Socials;
